module.exports = __webpack_public_path__ + "img/erudio_dinheiro.5bdcbf33.svg";